<template>
	<nav class="flex overflow-x-auto border-b border-gray-200 md:overflow-visible">
		<button
			v-for="tab in tabs"
			:key="tab.id"
			type="button"
			:data-test="tab.testId"
			class="shrink-0 whitespace-nowrap border-b-2 px-4 py-2 text-base font-medium"
			:class="
				activeTab === tab.id
					? 'text-gray-900 border-gray-900'
					: 'text-gray-500 border-transparent'
			"
			@click="$emit('select', tab.id)"
		>
			{{ tab.label }}
		</button>
	</nav>
</template>

<script>
export default {
	props: {
		tabs: { type: Array, required: true },
		activeTab: { type: String, required: true }
	}
}
</script>
